import { IWebsiteBuilderNodeBase } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderNode";
import { INodeSnapshot, WebsiteBuilderActionType } from "../../websiteBuilderAction";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";
import { cloneDeep } from "lodash";
import { IAddNodeAction } from "./addNodeAction";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";

export interface IDeleteNodeActionPayload {
  snapshot: INodeSnapshot;
}

export interface IDeleteNodeAction {
  type: typeof WebsiteBuilderActionType.DELETE_NODE;
  payload: IDeleteNodeActionPayload;
}

export function getDeleteNodeInverseAction(action: IDeleteNodeAction): IAddNodeAction {
  const { snapshot } = action.payload;

  return {
    type: WebsiteBuilderActionType.ADD_NODE,
    payload: {
      snapshot: cloneDeep(snapshot),
    },
  };
}

interface IDeleteNodeTreeTraversalNode extends IWebsiteBuilderNodeBase {
  children?: IWebsiteBuilderNodeBase[];
}

function deleteNodeTreeTraversal(tree: IWebsiteBuilderRoot, deleteId: string): IWebsiteBuilderRoot {
  function traverse(node: IDeleteNodeTreeTraversalNode): IDeleteNodeTreeTraversalNode {
    if (!node.children) {
      return node;
    } else {
      return {
        ...node,
        children: node.children.filter(child => child.id !== deleteId).map(child => traverse(child)),
      };
    }
  }

  let updatedTree = traverse(tree) as IWebsiteBuilderRoot;

  updatedTree = {
    ...updatedTree,
    header: traverse(tree.header) as IWebsiteBuilderHeader,
    footer: traverse(tree.footer) as IWebsiteBuilderFooter,
  };

  return updatedTree;
}

export function applyDeleteNodeTreeChange(tree: IWebsiteBuilderRoot, action: IDeleteNodeAction): IWebsiteBuilderRoot {
  const deleteId = action.payload.snapshot.node.id;

  if (tree.id === deleteId || tree.header.id === deleteId || tree.footer.id === deleteId) {
    return tree;
  }

  const updatedTree = deleteNodeTreeTraversal(tree, deleteId);

  return updatedTree;
}
